import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useStudentsService } from '../../../../apis/students/useStudentsService';
import { TStudentDetails } from '../../../../apis/students/students.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStudentDetailsByIdKey = 'get-student-details-by-id';

export const useStudentDetailsByIdHook = (
  id: string,
  options?: Partial<
    Omit<UseQueryOptions<TStudentDetails, TQueryError>, 'queryKey' | 'queryFn'>
  >
): UseQueryResult<TStudentDetails, TQueryError> => {
  const { getStudentDetailsbyId } = useStudentsService();

  return useQuery<TStudentDetails, TQueryError>({
    queryKey: [getStudentDetailsByIdKey, id],
    queryFn: () => getStudentDetailsbyId(id),
    enabled: true,
    ...options,
  });
};
